import React from 'react';
import { Link } from 'react-router-dom';
import './contact.scss';

const Contact = () => {
    return (
        <div className="contact-touch">
            <div className="container">
                <div className="heading">
                    <h3>What's Next?</h3> 
                </div>
                <h2>Get In Touch</h2>
                <p>Although I'm not currently looking for any new opportunities, my inbox is always open. Whether you have a question or just want to say hi, I'll try my best to get back to you!</p>
                <Link role="button" to="/contact" className="btn btn-blank">Say Hello</Link>
            </div>
        </div>
    );
};

export default Contact;